import foreignTerritories from 'ui-kit/inputs/geo-data/foreign-territory.json';

import { CountryCode } from '@agentnet/utils';

export const countryOptions = [
  { value: CountryCode.US, label: 'United States', name: 'United States' },
  ...foreignTerritories.map((territory) => ({
    value: territory.abbreviation,
    name: territory.name,
  })),
];

export const foreignTerritoryOptions = foreignTerritories.map((territory) => ({
  value: territory.abbreviation,
  label: territory.name,
  name: territory.name,
}));

export const beneficialOwnerCategoryOptions = [
  {
    value: 'trustee',
    label: 'An individual who is a trustee of the trust transferee trust',
    name: 'Individual trustee',
  },
  {
    value: 'authorityDispose',
    label: 'An individual other than a trustee with the authority to dispose of transferee trust assets',
    name: 'Individual with authority to dispose of assets',
  },
  {
    value: 'beneficiaryIncome',
    label:
      'A beneficiary who is the sole permissible recipient of income and principal from the transferee trust or who has the right to demand a distribution of, or withdraw, substantially all of the assets from the transferee trust',
    name: 'Sole permissible recipient of trust income or assets',
  },
  {
    value: 'grantorRevoke',
    label:
      'A grantor or settlor who has the right to revoke the transferee trust or otherwise withdraw the assets of the transferee trust',
    name: 'Grantor or settlor with the right to revoke or withdraw assets',
  },
  {
    value: 'entityTrustee',
    label: 'A beneficial owner of a legal entity or trust that is a trustee of the transferee trust',
    name: 'Beneficial owner of a legal entity or trust that is a trustee',
  },
  {
    value: 'entityAuthorityDispose',
    label: 'Beneficial owner of a legal entity or trust with authority to dispose of assets',
    name: 'Beneficial owner of a legal entity or trust with authority to dispose of assets',
  },
  {
    value: 'entityBeneficiary',
    label:
      'A beneficial owner of a legal entity or trust that is the sole permissible recipient of income and principal from the transferee trust or who has the right to demand a distribution of, or withdraw, substantially all of the assets from the transferee trust',
    name: 'Beneficial owner of a legal entity or trust that is the sole permissible recipient of trust income or assets',
  },
  {
    value: 'entityGrantor',
    label:
      'A beneficial owner of a legal entity or trust that is a grantor or settlor with the right to revoke the transferee trust or otherwise withdraw the assets of the transferee trust',
    name: 'Beneficial owner of legal entity or trust that is a grantor or settlor with the right to revoke or withdraw assets',
  },
];

export const baseIdentificationTypeOptions = [
  { value: 'ein', label: 'EIN', name: 'EIN' },
  { value: 'ssn-itin', label: 'SSN-ITIN', name: 'SSN-ITIN' },
  { value: 'foreignTaxId', label: 'Foreign Tax Identification Number', name: 'Foreign Tax Identification Number' },
  { value: 'foreignPassport', label: 'Foreign Passport', name: 'Foreign Passport' },
  {
    value: 'foreignEntityRegistrationNumber',
    label: 'Foreign Entity Registration Number',
    name: 'Foreign Entity Registration Number',
  },
  { value: 'noIdentification', label: 'No Identification', name: 'No Identification' },
];

export const authorizationCapacityOptions = [
  { value: 'employee', label: 'Employee', name: 'Employee' },
  { value: 'agent', label: 'Agent', name: 'Agent' },
  { value: 'partner', label: 'Partner', name: 'Partner' },
  { value: 'officer', label: 'Officer', name: 'Officer' },
  { value: 'counsel', label: 'Counsel', name: 'Counsel' },
  { value: 'trustee', label: 'Trustee', name: 'Trustee' },
  { value: 'other', label: 'Other', name: 'Other' },
];

export const entityTypeOptions = [
  { value: 'corporation', label: 'Corporation', name: 'Corporation' },
  { value: 'llc', label: 'Limited Liability Company', name: 'Limited Liability Company' },
  { value: 'partnership', label: 'Partnership', name: 'Partnership' },
  { value: 'other', label: 'Other', name: 'Other' },
];

export enum TransfereeType {
  ENTITY = 'entity',
  TRUST = 'trust',
}

export const addressTypeOptions = [
  {
    value: 'primary',
    label: 'Primary U.S. location where entity conducts business',
    name: 'Primary U.S. location where entity conducts business',
  },
  { value: 'foreign', label: 'Principal Place of Business (U.S.)', name: 'Principal Place of Business (U.S.)' },
];
